import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

/**
 * Language switcher component
 * Toggles between Japanese and English
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ja' ? 'en' : 'ja';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-switcher"
      aria-label="Switch language"
      type="button"
    >
      {i18n.language === 'ja' ? 'English' : '日本語'}
    </button>
  );
}
